<template>
  <el-table-column
    prop="customer_order.receipt_number"
    sortable="custom"
    label="Kapcsolódó megrendelés"
    show-overflow-tooltip
    min-width="220"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.customer_order_receipt_number"
        style="display: inline-block;"
      >
        <remote-link
          :label="scope.row.customer_order_receipt_number"
          :path="scope.row.customer_order_receipt_file_url"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó megrendelés</el-tag>
    </template>
  </el-table-column>
</template>

<script>
import RemoteLink from '../../../utils/RemoteLink';

export default {
  components: { RemoteLink },
  propName: 'customer_order.receipt_number',
};
</script>

